import { Databases, ID, Query } from 'appwrite';
import client from '../app-user';

const databases = new Databases(client);

export const DATABASE_ID = process.env.REACT_APP_DATABASE_ID || 'database';
export const HOME_CONTENT_COLLECTION_ID = process.env.REACT_APP_HOME_CONTENT_COLLECTION_ID || 'home-content';
export const COMMISSIONER_NOTE_ID = 'commissioner-note';

export interface HomeContentDocument {
  $id: string;
  contentType: 'commissioner_note' | 'league_news';
  title: string;
  body: string;
  url?: string;
  sortOrder: number;
  published: boolean;
}

export const listHomeContent = async (includeUnpublished = false): Promise<HomeContentDocument[]> => {
  const queries = [Query.orderAsc('sortOrder'), Query.limit(100)];
  if (!includeUnpublished) queries.unshift(Query.equal('published', true));
  const result = await databases.listDocuments(DATABASE_ID, HOME_CONTENT_COLLECTION_ID, queries);
  return result.documents as unknown as HomeContentDocument[];
};

export const saveCommissionerNote = async (body: string): Promise<HomeContentDocument> => {
  const payload = { contentType: 'commissioner_note', title: 'Note from the commish', body, sortOrder: 0, published: true };
  try {
    return await databases.updateDocument(DATABASE_ID, HOME_CONTENT_COLLECTION_ID, COMMISSIONER_NOTE_ID, payload) as unknown as HomeContentDocument;
  } catch (error) {
    if ((error as { code?: number }).code !== 404) throw error;
    return await databases.createDocument(DATABASE_ID, HOME_CONTENT_COLLECTION_ID, COMMISSIONER_NOTE_ID, payload) as unknown as HomeContentDocument;
  }
};

export const saveLeagueNewsItem = async (
  item: Omit<HomeContentDocument, '$id' | 'contentType'> & { $id?: string }
): Promise<HomeContentDocument> => {
  const payload = {
    contentType: 'league_news',
    title: item.title,
    body: item.body,
    url: item.url || '',
    sortOrder: item.sortOrder,
    published: item.published,
  };
  if (item.$id) {
    return await databases.updateDocument(DATABASE_ID, HOME_CONTENT_COLLECTION_ID, item.$id, payload) as unknown as HomeContentDocument;
  }
  return await databases.createDocument(DATABASE_ID, HOME_CONTENT_COLLECTION_ID, ID.unique(), payload) as unknown as HomeContentDocument;
};

export const deleteLeagueNewsItem = (documentId: string) => databases.deleteDocument(
  DATABASE_ID,
  HOME_CONTENT_COLLECTION_ID,
  documentId
);
